const state = () => {
    return {};
};

// actions
const actions = {
    clearStore({ commit }) {
        commit("clearStore");
    },
    setStore({ commit }, store) {
        commit("setStore", store);
    },
};

// mutations
const mutations = {
    clearStore(state) {
        for (const property in state) {
            if (state.hasOwnProperty(property)) {
                delete state[property];
            }
        }
    },
    setStore(state, store) {
        Object.assign(state, store);
    },
};

// getters
const getters = {
    getAllUserInfo: (state) => state,
    getUserInfoForApi: ({title, name, surname, position, organization: {org_name}, uid}) => {
        return {
            title,
            name,
            surname,
            position,
            org_name,
            modified_by_system: "mso-logbook",
            uid,
        };
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};